import { useMetricEvents } from '@/composables/useMetricEvents'

const PWA_INSTALLED_KEY = 'evergpt-pwa-installed-event-sent'

function isStandaloneDisplay(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone ===
      true
  )
}

function markPwaInstalledTracked() {
  try {
    localStorage.setItem(PWA_INSTALLED_KEY, '1')
  } catch {
    /* ignore */
  }
}

function hasTrackedPwaInstall(): boolean {
  try {
    return localStorage.getItem(PWA_INSTALLED_KEY) === '1'
  } catch {
    return false
  }
}

/** Chrome / Edge: `appinstalled` fires when the user installs the PWA. */
export function registerPwaInstallAnalytics() {
  window.addEventListener('appinstalled', () => {
    markPwaInstalledTracked()
    useMetricEvents().sendEvent('pwa_installed')
  })
}

/**
 * Apple / Safari: Add to Home Screen does not fire `appinstalled`.
 * On first authenticated open in standalone mode, send the same install event once.
 */
export function trackStandalonePwaInstall() {
  if (!isStandaloneDisplay() || hasTrackedPwaInstall()) return

  markPwaInstalledTracked()
  useMetricEvents().sendEvent('pwa_installed')
}
